import { render, staticRenderFns } from "./orderAllItem.vue?vue&type=template&id=a9fc6948&scoped=true&"
import script from "./orderAllItem.vue?vue&type=script&lang=js&"
export * from "./orderAllItem.vue?vue&type=script&lang=js&"
import style0 from "./orderAllItem.vue?vue&type=style&index=0&id=a9fc6948&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9fc6948",
  null
  
)

export default component.exports